export default class List {
    private static upQuantityUrl = '?ajaxAction=basketUpProductQuantity';

    private static downQuantityUrl = '?ajaxAction=basketDownProductQuantity';

    public static init() {
        const cardButtonsContainers = document.querySelectorAll(
            '.catalog_block_new_template .catalog_block .item_block .catalog_item .footer_button'
        ) as unknown as HTMLElement[];

        cardButtonsContainers.forEach((container) => {
            const observerAddToCartButton = new MutationObserver(
                this.addToCartCallback
            );
            const observerContainer = new MutationObserver(
                this.containerCallback
            );
            /*const observerMiniCart = new MutationObserver(
                this.miniCartCallback
            );*/
            const counterBlock = container.querySelector(
                '.counter_block'
            ) as HTMLElement;
            const buttonBlock = container.querySelector(
                '.button_block'
            ) as HTMLElement;
            const buttonAddToCart = container.querySelector(
                '.to-cart'
            ) as HTMLElement;
            const imgPreloader = document.createElement('img');
            /*const miniBasket = document.querySelector('.basket-link');*/

            imgPreloader.src =
                '/local/templates/5lb/images/loaders/preloader.gif';
            imgPreloader.style.position = 'absolute';
            imgPreloader.style.right = '12px';
            imgPreloader.style.top = '14px';

            if (counterBlock !== null) {
                // Этот товар в корзине
                if (counterBlock.style.display === 'none') {
                    const productId = counterBlock.dataset.item;

                    counterBlock.style.display = 'flex';
                    counterBlock.querySelector('input').disabled = true;
                    buttonBlock.style.display = 'none';
                    fetch(
                        `?ajaxAction=getQuantityProduct&id=${productId}`
                    ).then(async (response) => {
                        const quantity = await response.json();

                        counterBlock
                            .querySelector('input')
                            .setAttribute('value', quantity);
                    });
                }
            }
            if (buttonAddToCart !== null) {
                if (buttonAddToCart.style.display !== 'none') {
                    counterBlock.style.display = 'none';
                }
            }
            if (buttonAddToCart !== null) {
                observerAddToCartButton.observe(buttonAddToCart, {
                    attributeOldValue: true,
                    attributes: true,
                    childList: true,
                    subtree: true,
                });
            }
            observerContainer.observe(container, {
                attributeOldValue: true,
                attributes: true,
                childList: true,
                subtree: true,
            });
            /*observerMiniCart.observe(miniBasket, {
                attributeOldValue: true,
                attributes: true,
                childList: true,
                subtree: true,
            });*/
            container.addEventListener('click', (event) => {
                let target = event.target as HTMLElement;

                if (target.closest('.plus')) {
                    target = target.closest('.plus');
                }
                if (target.closest('.minus')) {
                    target = target.closest('.minus');
                }
                const isPlus = target.classList.contains('plus');

                const isMinus = target.classList.contains('minus');

                if (isPlus && target.dataset.clicked !== 'true') {
                    const id = (
                        target.closest('div.counter_block') as HTMLDivElement
                    ).dataset.item;
                    const addProductUrl = `${List.upQuantityUrl}&productId=${id}`;
                    const { max } = target.dataset;
                    const idInput = (
                        target.parentNode as HTMLElement
                    ).querySelector('input').id;
                    const input = document.getElementById(
                        idInput
                    ) as HTMLInputElement;
                    const { value } = input;

                    if (Number(value) >= Number(max)) {
                        window.BX.UI.Notification.Center.notify({
                            content: 'Превышено допустимое количество товара для покупки',
                            autoHideDelay: 3000
                        });

                        target.style.opacity = '.5'

                        return;
                    } else {
                        target.style.opacity = '0';
                        imgPreloader.style.right = '12px';
                        imgPreloader.style.left = '';
                        target
                            .closest('.counter_block')
                            .appendChild(imgPreloader);
                    }
                    fetch(addProductUrl)
                        .then((response) => {
                            window.getActualBasket(26);

                            window.addBasketCounter(id);

                            window.basketTop(
                                'open',
                                $('.top_basket').find('.basket_hover_block')
                            );
                            window.BX.onCustomEvent('onCompleteAction', [
                                { action: 'loadForm' },
                                target
                                    .closest('.inner_wrap')
                                    .querySelector('.button_block span'),
                            ]);
                            target
                                .closest('.counter_block')
                                .querySelector('img')
                                .remove();
                            target.style.opacity = '1';

                            return response.json();
                        })
                        .then((response) => {
                            $('.basket-link.basket.basket-count')
                                .find('.count')
                                .text(response.total_quantity);
                        });
                }
                if (isMinus) {
                    const id = (
                        target.closest('div.counter_block') as HTMLDivElement
                    ).dataset.item;
                    const downProductUrl = `${List.downQuantityUrl}&productId=${id}&basketItemId=${id}`;
                    const idInput = (
                        target.parentNode as HTMLElement
                    ).querySelector('input').id;
                    const input = document.getElementById(
                        idInput
                    ) as HTMLInputElement;


                    target.style.opacity = '0';
                    imgPreloader.style.left = '12px';
                    imgPreloader.style.right = '';
                    target.closest('.counter_block').appendChild(imgPreloader);

                    fetch(downProductUrl)
                        .then((response) => {
                            window.getActualBasket(26);

                            window.addBasketCounter(id);

                            window.basketTop(
                                'open',
                                $('.top_basket').find('.basket_hover_block')
                            );
                            window.BX.onCustomEvent('onCompleteAction', [
                                { action: 'loadForm' },
                                target
                                    .closest('.inner_wrap')
                                    .querySelector('.button_block span'),
                            ]);
                            target
                                .closest('.counter_block')
                                .querySelector('img')
                                .remove();
                            (
                                target
                                    .closest('.counter_wrapp')
                                    .querySelector(
                                        '.plus'
                                    ) as HTMLElement
                            ).style.opacity = '1';
                            target.style.opacity = '1';
                            return response.json();
                        })
                        .then((result) => {
                            $('.basket-link.basket.basket-count')
                                .find('.count')
                                .text(result.total_quantity);
                            if (result.status === 2) {
                                (
                                    target
                                        .closest('.counter_wrapp')
                                        .querySelector(
                                            '.counter_block'
                                        ) as HTMLElement
                                ).style.display = 'none';
                                (
                                    target
                                        .closest('.counter_wrapp')
                                        .querySelector(
                                            '.button_block'
                                        ) as HTMLElement
                                ).style.display = 'block';
                                (
                                    target
                                        .closest('.counter_wrapp')
                                        .querySelector(
                                            '.button_block span'
                                        ) as HTMLElement
                                ).style.display = 'block';
                                window.addBasketCounter(id);

                                window.basketTop(
                                    'open',
                                    $('.top_basket').find('.basket_hover_block')
                                );
                                window.BX.onCustomEvent('onCompleteAction', [
                                    { action: 'loadForm' },
                                    target
                                        .closest('.inner_wrap')
                                        .querySelector('.button_block span'),
                                ]);
                                observerContainer.disconnect();
                            }
                        });
                }
            });
        });
    }

    private static addToCartCallback(mutationsList: any, observer: any) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'attributes') {
                if (mutation.target.style.display === 'none') {
                    mutation.target.nextSibling.style.display = 'none';
                    const counterBlock =
                        mutation.target.parentNode.parentNode.querySelector(
                            '.counter_block'
                        );

                    counterBlock.style.display = 'flex';
                }
                if (
                    mutation.attributeName === 'style' &&
                    mutation.oldValue === 'display: none;'
                ) {
                    const counterBlock =
                        mutation.target.parentNode.parentNode.querySelector(
                            '.counter_block'
                        );

                    counterBlock.style.display = 'none';
                }
            }
        }
    }

    private static containerCallback(mutationsList: any, observer: any) {
        for (const mutation of mutationsList) {
            if (
                mutation.type === 'attributes' &&
                mutation.attributeName === 'style'
            ) {
                if (
                    mutation.oldValue === 'display: none;' &&
                    mutation.target.style.display === ''
                ) {
                    mutation.target.style.display = 'none';
                }
                if (
                    mutation.oldValue === 'display: flex;' &&
                    mutation.target.classList.contains('counter_block')
                ) {
                    const idInput = (
                        mutation.target.parentNode as HTMLElement
                    ).querySelector('input').id;

                    document.getElementById(idInput).value = 1;

                    mutation.target.style.display = 'none';
                    const idButtonBlock =
                        mutation.target.parentNode.querySelector(
                            '.button_block'
                        ).id;
                    document.getElementById(idButtonBlock).style.display =
                        'block';
                    const liveButtonBlock =
                        document.getElementById(idButtonBlock);
                    liveButtonBlock.querySelector('span').dataset.quantity =
                        String(1);
                }
            }
        }
    }
}
